<div [ngClass]="colorClass" matRipple>
    <ng-content></ng-content>
</div>
